<div class="image-modal">
    <img [src]="data.file" alt="Image Preview" style="max-width: 100%; max-height: 100%;" >
</div>